// extracted by mini-css-extract-plugin
export default {"seconds":"Mngfsm","milliseconds":"DIFWZO"};